import { createClient } from '@infuse/api/common';
import { InfuseService } from './model';

const client = createClient('/rest/services');

export const getInfuseServices = async function (): Promise<InfuseService[]> {
  try {
    const response = await client.get<InfuseService[]>('');
    return response.data;
  } catch (error: unknown) {
    return [];
  }
};
